module.exports = __webpack_public_path__ + "img/rsini_5.bd2af3d8.jpg";